import { render, staticRenderFns } from "./AccountSettingSocial.vue?vue&type=template&id=33d015e4&scoped=true&"
import script from "./AccountSettingSocial.vue?vue&type=script&lang=js&"
export * from "./AccountSettingSocial.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingSocial.vue?vue&type=style&index=0&id=33d015e4&scoped=true&lang=scss&"
import style1 from "./AccountSettingSocial.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d015e4",
  null
  
)

export default component.exports